var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("v-container", [
    _c("h1", [_vm._v("Project Initialized")]),
    _c("p", [_vm._v("Project Initialized. Hooray!")]),
    _c(
      "a",
      {
        attrs: {
          href: `/#/pages/research/client/${_vm.$route.params.clientId}`,
        },
      },
      [_vm._v("Back to client info")]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }